'use strict';

import resizeStore from '../resize/resize.store';
import dispatcher from '../dispatcher';
import { gsap } from 'gsap';
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
gsap.registerPlugin(MorphSVGPlugin)

function getRandomArbitrary(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

class Morph extends HTMLAnchorElement{
  constructor() {
    super();

    this._svg = this.querySelector('.morf-elem');
    this._svgHover = this.querySelector('.svg-morf');

    this.onResize = () => this._onResize();
    this.onAnimate = () => this._onAnimate();

    this.onMouseMove = (e) => this._onMouseMove(e);
  }
  connectedCallback() {
    this._onResize();
    resizeStore.eventEmitter.addListener(this.onResize);

    this.addEventListener('mouseenter', this._onHover);
    this.addEventListener('mouseleave', this._onBlur);
  }
  disconnectedCallback() {
    resizeStore.eventEmitter.removeListener(this.onResize);

    this.removeEventListener('mouseenter', this._onHover);
    this.removeEventListener('mouseleave', this._onBlur);
  }

  _onHover() {
    let numb = getRandomArbitrary(1,5);
    gsap.to(this._svgHover, {morphSVG: `#btn-finish-${numb}`, duration: .5})
  }
  _onBlur() {
    gsap.to(this._svgHover, {morphSVG: '#btn-start', duration: .5})
  }

  _onResize() {

  }

  _onMouseMove(e) {
    e.preventDefault();
  }


}

window.customElements.define('morf-link', Morph, { extends: 'a' });
